(ns minorodata.components.home-dashboard.extracts
  (:require
   ["date-fns" :refer [differenceInSeconds format parseISO]]
   ["lucide-react" :refer [DatabaseIcon]]
   [applied-science.js-interop :as jsi]
   [minorodata.app.utils :as app.utils :refer [format-date]]
   [minorodata.components.home-dashboard.shared :refer [chart-colors format-duration mini-stat
                                                          percentage-formatter stat-card]]
   [minorodata.components.spinner.core :as spinner]
   [re-frame.core :as re-frame]
   [re-posh.core :as re-posh]
   [reagent.core :as reagent]
   [recharts :refer [Bar BarChart CartesianGrid ComposedChart Legend Pie
                     PieChart Tooltip XAxis YAxis]]
   [reitit.frontend.easy :as rt.easy]
   [ui.card :as card]
   [ui.hover-card :as hover-card]
   [ui.table :as table]
   [ui.typography :as typography]))

(defn connectors-count-card []
  (let [data @(re-frame/subscribe [:analytics.subs/connectors-summary])
        loading? @(re-frame/subscribe [:mold-http/loading? :analytics.api/fetch-sources])]
    [hover-card/hover-card-root
     [hover-card/hover-card-trigger {:class "block text-left"}
      [mini-stat
       {:icon       [:> DatabaseIcon]
        :icon-class (str
                     "border border-extracts "
                     "bg-kleene-background "
                     "[&>svg]:text-extracts")
        :title      "Connectors"
        :value      (:total data)
        :loading    loading?}]]
     [hover-card/hover-card-content
      [typography/h4 {:class "mb-4"} "Sources by connector"]
      [:> PieChart {:data (map-indexed (fn [i [k v]]
                                         {:name  k
                                          :value v
                                          :fill (nth chart-colors i "var(--color-slate-500)")})
                                       (->> (:types data) (sort-by val >) (take 10)))
                    :width 300
                    :height 400}
       [:> Tooltip]
       [:> Legend]
       [:> Pie {:dataKey       "value"
                :nameKey       "name"
                ;; :cx            "50%"
                ;; :cy            "50%"
                ;; :outerRadius   80
                :label         true
                :labelLine     false
                :isAnimationActive true}]]]]))

(defn db-connectors-count-card []
  (let [data @(re-frame/subscribe [:analytics.subs/db-connectors-summary])
        loading? @(re-frame/subscribe [:mold-http/loading? :analytics.api/fetch-sources])]
    [hover-card/hover-card-root
     [hover-card/hover-card-trigger {:class "block text-left"}
      [mini-stat
       {:icon       [:> DatabaseIcon]
        :icon-class (str
                     "border border-extracts "
                     "bg-kleene-background "
                     "[&>svg]:text-extracts")
        :title      "Database connectors"
        :value      (:total data)
        :loading    loading?}]]
     [hover-card/hover-card-content
      [typography/h4 {:class "mb-4"} "Sources by connector"]
      [:> PieChart {:data (map-indexed (fn [i [k v]]
                                         {:name  k
                                          :value v
                                          :fill (nth chart-colors i "var(--color-slate-500)")})
                                       (->> (:types data) (sort-by val >) (take 10)))
                    :width 300
                    :height 400}
       [:> Tooltip]
       [:> Legend]
       [:> Pie {:dataKey       "value"
                :nameKey       "name"
                ;; :cx            "50%"
                ;; :cy            "50%"
                ;; :outerRadius   80
                :label         true
                :labelLine     false
                :isAnimationActive true}]]]]))


(defn extracts-count-card []
  (let [data     @(re-frame/subscribe [:analytics.subs/summary-extracts])
        loading? @(re-frame/subscribe
                   [:mold-http/loading? :analytics.api/fetch-extracts])]
    [mini-stat
     {:icon       [:> DatabaseIcon]
      :icon-class (str
                   "bg-extracts/20 "
                   "[&>svg]:text-extracts")
      :title      "Extracts"
      :value      (:total data)
      :loading    loading?}]))

(defn execution-time-card []
  (let [data @(re-frame/subscribe [:analytics.subs/summary-extracts])
        loading? @(re-frame/subscribe [:mold-http/loading? :analytics.api/fetch-extracts])
        duration (get-in data [:execution-stats :total-exec-time :current])
        prev-duration (get-in data [:execution-stats :total-exec-time :previous])]
    [stat-card {:title "Total execution time"
                :value (if-not duration "N/A" (format-duration duration))
                :prev-value (when prev-duration (format-duration prev-duration))
                :trend (when (and duration prev-duration)
                         (cond (> duration prev-duration) :up
                               (< duration prev-duration) :down
                               :else :neutral))
                :invert true
                :loading loading?}]))

(defn data-extracted-card []
  #_[stat-card {:title "Data extracted"
                :value "32 GB"}])

(defn extracts-started-card []
  (let [data @(re-frame/subscribe [:analytics.subs/summary-extracts])
        loading? @(re-frame/subscribe [:mold-http/loading? :analytics.api/fetch-extracts])]
    [stat-card {:title "Extracts started"
                :value (get-in data [:execution-stats :total-runs :current] 0)
                :prev-value (get-in data [:execution-stats :total-runs :previous] 0)
                :loading loading?}]))

(defn extracts-succeeded-card []
  (let [data @(re-frame/subscribe [:analytics.subs/summary-extracts])
        loading? @(re-frame/subscribe [:mold-http/loading? :analytics.api/fetch-extracts])]
    [stat-card {:title "Extracts succeeded"
                :value (get-in data [:execution-stats :successful-runs :current] 0)
                :prev-value (get-in data [:execution-stats :successful-runs :previous] 0)
                :loading loading?}]))

(defn extracts-failed-card []
  (let [data @(re-frame/subscribe [:analytics.subs/summary-extracts])
        loading? @(re-frame/subscribe [:mold-http/loading? :analytics.api/fetch-extracts])]
    [stat-card {:title "Extracts failed"
                :value (get-in data [:execution-stats :failed-runs :current] 0)
                :prev-value (get-in data [:execution-stats :failed-runs :previous] 0)
                :invert true
                :loading loading?}]))

(defn extracts-success-rate-card []
  (let [data @(re-frame/subscribe [:analytics.subs/summary-extracts])
        loading? @(re-frame/subscribe [:mold-http/loading? :analytics.api/fetch-extracts])
        value (get-in data [:execution-stats :success-rate :current] 0)
        prev-value (get-in data [:execution-stats :success-rate :previous] 0)]
    [stat-card {:title "Success rate"
                :value (.format percentage-formatter (/ value 100))
                :prev-value (.format percentage-formatter (/ prev-value 100))
                :trend (cond (> value prev-value) :up
                             (< value prev-value) :down
                             :else :neutral)
                :loading loading?}]))

(defn extracts-executions-chart []
  (let [data @(re-frame/subscribe [:analytics.subs/summary-extracts])
        loading? @(re-frame/subscribe [:mold-http/loading? :analytics.api/fetch-extracts])]
    [card/card {:class "rounded-lg"}
     [card/card-content {:class "p-6"}
      [card/card-title {:class "mb-6"}
       "Extract executions over time"]
      [:div
       (if (or (not (:execution-timeline data)) loading?)
         [:div {:class "w-full flex items-center justify-center"}
          [spinner/with-text {:text "Loading executions chart..."}]]

         [:> ComposedChart {:width  "100%"
                            :height 300
                            :data   (or (:execution-timeline data) [])}
          [:> CartesianGrid {:vertical false}]
          [:> XAxis {:dataKey "period"
                     :axis-line false
                     :tick-formatter #(format % "d MMM yy HH:mm")}]
          [:> YAxis {:type "number"
                     :axis-line false
                     :tick-line false}]

          #_[:> Line {:dataKey "launches" :fill "var(--color-sky-700)" :stack-id "launched" :name "Launches"}]
          [:> Bar {:dataKey "succeeded" :fill "var(--color-emerald-500)" :name "Finished" :stack-id "finished"}]
          [:> Bar {:dataKey "failed" :fill "var(--color-red-400)" :name "Failed" :stack-id "finished"}]
          [:> Tooltip {:label-formatter #(format % "d MMM yy HH:mm")}]
          [:> Legend]])]]]))

(defn slowest-extracts-table []
  (let [data @(re-frame/subscribe [:analytics.subs/summary-extracts])
        loading? @(re-frame/subscribe [:mold-http/loading? :analytics.api/fetch-extracts])]
    [card/card {:class "rounded-lg"}
     [card/card-content {:class "p-6"}
      [card/card-title {:class "mb-6"}
       "Slowest 10 extract runs"]
      (if loading?
        [:div {:class "w-full flex items-center justify-center"}
         [spinner/with-text {:text "Loading slowest extract runs..."}]]

        [:div {:class "overflow-x-auto"}
         [table/table {:class "min-w-full"}
          [table/thead
           [table/tr
            [table/th "Run time"]
            [table/th "Extract"]
            [table/th "Source name"]
            [table/th "Last start time"]]]
          [table/tbody
           (for [row (:slowest data)]
             [table/tr {:key (str (:extract-id row) (:end-time row))}
              [table/td {:class "whitespace-nowrap"} (format-duration (differenceInSeconds (parseISO (:end-time row)) (parseISO (:start-time row))))]
              [table/td {:class "whitespace-nowrap"}
               [:a {:class "text-kleene-text-link hover:underline"
                    :href (rt.easy/href :log {} {:source (:source-type row)
                                                 :term   (:extract-name row)})}
                (:extract-name row)]]
              [table/td {:class "whitespace-nowrap"} (:source-name row)]
              [table/td {:class "whitespace-nowrap"} (format-date (parseISO (:start-time row)))]])]]])]]))

(defn recently-failed-extracts-table []
  (let [data @(re-frame/subscribe [:analytics.subs/summary-extracts])
        loading? @(re-frame/subscribe [:mold-http/loading? :analytics.api/fetch-extracts])]
    [card/card {:class "rounded-lg"}
     [card/card-content {:class "p-6"}
      [card/card-title {:class "mb-6"}
       "Most recent 10 extract failures"]
      [:div {:class "overflow-x-auto"}
       (if loading?
         [:div {:class "w-full flex items-center justify-center"}
          [spinner/with-text {:text "Loading recently failed extracts..."}]]

         [table/table {:class "min-w-full"}
          [table/thead
           [table/tr
            [table/th "Failure time"]
            [table/th "Extract"]
            [table/th "Source name"]]]
          [table/tbody
           (for [row (:recently-failed data)]
             [table/tr {:key (str (:extract-id row) (:failed-at row))}
              [table/td {:class "whitespace-nowrap"} (format-date (:failed-at row))]
              [table/td {:class "whitespace-nowrap"}
               [:a {:class "text-kleene-text-link hover:underline"
                    :href (rt.easy/href :log {} {:source (:source-type row)
                                                 :term   (:extract-name row)})}
                (:extract-name row)]]
              [table/td {:class "whitespace-nowrap"} (:source-name row)]])]])]]]))

(defn connector-tick [images props]
  (let [width 60
        height 46
        name (jsi/get-in props [:payload :value])
        img (get images name)]
    (reagent/as-element
     (if img
       [:image {:href   (app.utils/maybe-local-url img)
                :height height
                :width  width
                :x (- (jsi/get props :x) (/ (jsi/get props :width) 2) (/ width 2))
                :y (- (jsi/get props :y) (/ height 2))}]
       [:text   {:x (- (jsi/get props :x) (/ (jsi/get props :width) 2) (/ width 2))
                 :y (jsi/get props :y)}
        name]))))

(defn total-connector-runtime-chart []
  (let [connectors @(re-posh/subscribe [:connections.subs/all-connectors])
        connector-names (->> connectors (mapv (fn [{:keys [id name]}] [id name])) (into {}))
        images (->> connectors (mapv (fn [{:keys [id image-source]}] [id image-source])) (into {}))
        data @(re-frame/subscribe [:analytics.subs/summary])
        loading? @(re-frame/subscribe [:mold-http/loading? :analytics.api/fetch-connectors])]
    [card/card {:class "rounded-lg"}
     [card/card-content {:class "p-6"}
      [card/card-title {:class "mb-6"}
       "Top 5 connectors by total runtime"]
      [:div
       (if loading?
         [:div {:class "w-full flex items-center justify-center"}
          [spinner/with-text {:text "Loading connectors runtime chart..."}]]

         [:> BarChart {:width  "100%"
                       :height 300
                       :layout "vertical"
                       :data   (or (mapv #(update % :total-runtime-seconds (fn [s] (js/Math.floor (/ s 60))))
                                         (:top-connectors-by-runtime data))
                                   [])}
          [:> CartesianGrid {:horizontal false}]
          [:> XAxis {:type "number" :hide true}]
          [:> YAxis {:dataKey "connector"
                     :type "category"
                     :axis-line false
                     :tick-line false
                     :tick (partial connector-tick images)
                     :tick-formatter (fn [v] (get connector-names v v))
                     :width 86}]

          [:> Bar {:dataKey "total-runtime-seconds" :name "Minutes" :fill "var(--color-sky-500)" :radius 5}]
          [:> Tooltip {:label-formatter (fn [v] (get connector-names v v))}]])]]]))
